import React from "react";
import Forward from "../../assets/assets/arrow-forward.svg";
import { PropTypes } from "prop-types";

export const Product = ({ id, docName, docUrl, goToSinglePage, iconUrl, colorCode }) => {
  return (
    <div className="documentation-item" key={id}>
        <div className="documentation-item-image">
          <div className="documentation-item-image-holder">
            <img src={iconUrl} alt="icon" />
          </div>
        </div>
      <h1>{docName}</h1>
      <h2>Get access to {docName} and other related documents</h2>
      <div
        className="view-sec"
        onClick={() => goToSinglePage(id, docUrl, docName, colorCode)}
      >
        view &nbsp; <img src={Forward} alt="icon" />
      </div>
    </div>
  );
};

Product.propTypes = {
  colorCode: PropTypes.string,
  docName: PropTypes.string,
  docUrl: PropTypes.string,
  goToSinglePage: PropTypes.func,
  iconUrl: PropTypes.string,
  id: PropTypes.number
};

export default Product;
